const escapeXml = value => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');

const getFirstLabel = vm => {
    const state = vm && vm.runtime && vm.runtime.visionClassifier &&
        typeof vm.runtime.visionClassifier.getState === 'function' &&
        vm.runtime.visionClassifier.getState();
    const labels = state && Array.isArray(state.labels) ? state.labels : [];
    return labels[0] || '';
};

const buildMoveWhenDataMatchesXml = vm => {
    const label = escapeXml(getFirstLabel(vm));

    return `<xml xmlns="http://www.w3.org/1999/xhtml">
  <block type="event_whenflagclicked" x="48" y="48">
    <next>
      <block type="control_forever">
        <statement name="SUBSTACK">
          <block type="control_if">
            <value name="CONDITION">
              <block type="visionClassifier_isVisionLabel">
                <field name="LABEL">${label}</field>
              </block>
            </value>
            <statement name="SUBSTACK">
              <block type="motion_movesteps">
                <value name="STEPS">
                  <shadow type="math_number">
                    <field name="NUM">10</field>
                  </shadow>
                </value>
              </block>
            </statement>
          </block>
        </statement>
      </block>
    </next>
  </block>
</xml>`;
};

const buildGoToNoseForeverXml = () => `<xml xmlns="http://www.w3.org/1999/xhtml">
  <block type="event_whenflagclicked" x="48" y="48">
    <next>
      <block type="control_forever">
        <statement name="SUBSTACK">
          <block type="bodySensing_goToBodyPart">
            <field name="BODY_PART">nose</field>
          </block>
        </statement>
      </block>
    </next>
  </block>
</xml>`;

const getCodeLibraryExamples = vm => ([
    {
        id: 'move-when-data-matches',
        title: 'Gå når data passer',
        description: 'Når flaget klikkes, går figuren fremad, når data matcher den valgte klasse.',
        xml: buildMoveWhenDataMatchesXml(vm)
    },
    {
        id: 'follow-nose',
        title: 'Følg næsen',
        description: 'Når flaget klikkes, følger figuren din næse hele tiden.',
        xml: buildGoToNoseForeverXml()
    }
]);

export default getCodeLibraryExamples;
